import { Button } from "@/components/ui/button";
import { User, LogOut } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { C } from "./data";

export const Header = ({ navigate, isAuthenticated, user, logout, onLogin }) => (
  <nav className="fixed top-0 left-0 right-0 z-50" style={{ background: 'rgba(16,28,43,0.95)', backdropFilter: 'blur(20px)', borderBottom: `1px solid ${C.darkBorder}` }} data-testid="landing-header">
    <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3 cursor-pointer group" onClick={() => navigate('/')}>
        <div className="relative zz-logo-wrap">
          <div className="absolute inset-0 blur-xl rounded-full scale-75 group-hover:scale-110 transition-transform duration-500" style={{ background: 'rgba(0,229,255,0.2)' }} />
          <img src="/zerozone-logo.png" alt="ZeroZone" className="relative w-36 h-36 md:w-44 md:h-44 object-contain zz-logo-img transition-all duration-500 ease-out" />
        </div>
        <div className="hidden md:flex flex-col">
          <span className="text-xs md:text-sm font-bold tracking-wider" style={{ color: '#FFFFFF' }}>Global Resilience Architect</span>
          <span className="text-[11px] md:text-xs font-semibold tracking-widest uppercase mt-0.5" style={{ color: '#00E5FF' }}>Shift Left Security — Automated</span>
        </div>
      </div>
      <div className="hidden md:flex items-center gap-6">
        {[{ label: "Platform", href: "#platform" }, { label: "Solutions", href: "#solutions" }, { label: "Compliance", href: "#compliance" }].map(l => (
          <a key={l.label} href={l.href} className="text-sm transition-colors" style={{ color: C.darkText3 }} onMouseEnter={e => e.currentTarget.style.color = C.darkText1} onMouseLeave={e => e.currentTarget.style.color = C.darkText3}>{l.label}</a>
        ))}
        <button onClick={() => navigate('/demo')} className="text-sm transition-colors" style={{ color: C.darkText3 }} data-testid="nav-demo-link">Demo</button>
      </div>
      <div className="flex items-center gap-3">
        {isAuthenticated ? (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" className="text-xs" style={{ borderColor: C.darkBorder, color: C.darkText3 }} data-testid="user-menu-trigger"><User className="w-4 h-4 mr-2" />{user?.username}</Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent style={{ background: C.darkSurface, borderColor: C.darkBorder }}>
              <DropdownMenuLabel style={{ color: C.darkText4 }}>{user?.email}</DropdownMenuLabel>
              <DropdownMenuSeparator style={{ background: C.darkBorder }} />
              <DropdownMenuItem onClick={() => navigate('/projects')} className="cursor-pointer" style={{ color: C.darkText3 }}>My Projects</DropdownMenuItem>
              <DropdownMenuSeparator style={{ background: C.darkBorder }} />
              <DropdownMenuItem onClick={logout} className="cursor-pointer" style={{ color: C.red }} data-testid="logout-btn"><LogOut className="w-4 h-4 mr-2" />Sign Out</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        ) : (
          <button className="text-sm transition-colors" style={{ color: C.darkText3 }} onClick={onLogin} data-testid="login-btn">Log in</button>
        )}
        <Button className="font-semibold px-5 py-2 rounded-md text-sm" style={{ background: C.dark, color: C.darkText1 }}
          onMouseEnter={e => e.currentTarget.style.opacity = '0.9'}
          onMouseLeave={e => e.currentTarget.style.opacity = '1'}
          onClick={() => navigate('/wizard')} data-testid="header-cta-btn"
        >
          Contact us
        </Button>
      </div>
    </div>
  </nav>
);
